import script from "./CellEmployee.vue?vue&type=script&setup=true&lang=js"
export * from "./CellEmployee.vue?vue&type=script&setup=true&lang=js"

import "./CellEmployee.vue?vue&type=style&index=0&id=3d4895b3&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3d4895b3"]])

export default __exports__